import { getCountryDevicesQuantity, getStateDevicesQuantity, getCityDevicesQuantity, getQueryDevicesByCity } from './map-data';

export const WAIT_INIT_MAP = 'WAIT_INIT_MAP';
export const GET_COUNTRY_QUANTITY = 'GET_COUNTRY_QUANTITY';
export const GET_COUNTRY_QUANTITY_SUCCESS = 'GET_COUNTRY_QUANTITY_SUCCESS';
export const GET_COUNTRY_QUANTITY_FAIL = 'GET_COUNTRY_QUANTITY_FAIL';
export const GET_STATE_QUANTITY = 'GET_STATE_QUANTITY';
export const GET_STATE_QUANTITY_SUCCESS = 'GET_STATE_QUANTITY_SUCCESS';
export const GET_STATE_QUANTITY_FAIL = 'GET_STATE_QUANTITY_FAIL';
export const GET_CITY_QUANTITY = 'GET_CITY_QUANTITY';
export const GET_CITY_QUANTITY_SUCCESS = 'GET_CITY_QUANTITY_SUCCESS';
export const GET_CITY_QUANTITY_FAIL = 'GET_CITY_QUANTITY_FAIL';
export const QUERY_DEVICES = 'QUERY_DEVICES';
export const QUERY_DEVICES_SUCCESS = 'QUERY_DEVICES_SUCCESS';
export const QUERY_DEVICES_FAIL = 'QUERY_DEVICES_FAIL';

export const forwardMap = () => (dispatch) => {
    dispatch({
        type: WAIT_INIT_MAP
    });
}

export const getDevicesQuantityInCountry = (idToken) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getCountryDevicesQuantity(resolve, reject, idToken);
    });

    doPost
    .then((data) => {
        let devicesQuantity = data.devicesQuantity;

        // get map online and offline devices size
        let monitorOnlineCount = 0;
        let monitorOfflineCount = 0;

        if (devicesQuantity) {
            devicesQuantity.forEach(element => {
                if (element) {
                    monitorOnlineCount += element.online;
                    monitorOfflineCount += element.offline;
                }
            });
        }

        dispatch({
            type: GET_COUNTRY_QUANTITY_SUCCESS,
            params: {
                countryQuantity: devicesQuantity,
                monitorOnline: monitorOnlineCount,
                monitorOffline: monitorOfflineCount
            }
        });
    })
    .catch((err) => {
        dispatch({
            type: GET_COUNTRY_QUANTITY_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: GET_COUNTRY_QUANTITY
    });
};

export const getDevicesQuantityInState = (idToken, countryName) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getStateDevicesQuantity(resolve, reject, idToken, countryName);
    });

    doPost
    .then((data) => {
        let devicesQuantity = data.devicesQuantity;
        let stateLoading = {};

        if (devicesQuantity) {
            devicesQuantity.forEach(element => {
                if (element) {
                    stateLoading[element.long_name] = element.total;
                }
            });
        }

        dispatch({
            type: GET_STATE_QUANTITY_SUCCESS,
            params: {
                countryName: countryName,
                stateLoading: stateLoading,
                stateQuantity: devicesQuantity
            }
        });
    })
    .catch((err) => {
        dispatch({
            type: GET_STATE_QUANTITY_FAIL,            
            params: {
                countryName: countryName,
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: GET_STATE_QUANTITY,
        params: {
            countryName: countryName
        }
    });
};

export const getDevicesQuantityInCity = (idToken, stateName) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getCityDevicesQuantity(resolve, reject, idToken, stateName);
    });

    doPost
    .then((data) => {
        let devicesQuantity = data.devicesQuantity;
        let loading = {};

        if (devicesQuantity) {
            devicesQuantity.forEach(element => {
                if (element) {
                    loading[element.long_name] = element.total;
                }
            });
        }

        dispatch({
            type: GET_CITY_QUANTITY_SUCCESS,
            params: {
                stateName: stateName,
                cityLoading: loading,
                cityQuantity: devicesQuantity
            }
        });
    })
    .catch((err) => {
        dispatch({
            type: GET_CITY_QUANTITY_FAIL,            
            params: {
                stateName: stateName,
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: GET_CITY_QUANTITY,
        params: {
            stateName: stateName
        }
    });
};

export const queryDevicesByCity = (idToken, cityName) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getQueryDevicesByCity(resolve, reject, idToken, cityName);
    });

    doPost
    .then((data) => {
        let devices = data.devices;

        dispatch({
            type: QUERY_DEVICES_SUCCESS,
            params: {
                devices: devices
            }
        });
    })
    .catch((err) => {
        dispatch({
            type: QUERY_DEVICES_FAIL,            
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: QUERY_DEVICES
    });
};